import { useEffect, useState } from "react";
import { SectionHeading } from "../../components/shared/SectionHeading";
import { EmptyState } from "../../components/shared/EmptyState";
import { Handshake, ExternalLink, MapPin } from "lucide-react";
import { api } from "../../lib/api";
import { usePageMedia } from "../../lib/usePageMedia";
import { usePageTexts } from "../../lib/usePageTexts";

export default function PartenairesPage() {
  const [partners, setPartners] = useState(null);
  const pageMedia = usePageMedia();
  const { text } = usePageTexts();
  const hero = pageMedia["partenaires:hero"];
  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => setPartners([]));
  }, []);

  return (
    <div className="container-ae py-12 md:py-16" data-testid="partenaires-page">
      <SectionHeading overline="Partenaires" title="Des partenaires" accent="de confiance">
        {text("partenaires:intro", "Lieux de réception, traiteurs, photographes… Art Event travaille avec des professionnels du Nord.")}
      </SectionHeading>
      {hero && (
        <img src={hero.url} alt={hero.alt || "Partenaires Art Event"} className="mb-10 aspect-[21/9] w-full rounded-xl object-cover" data-testid="page-hero-image" />
      )}
      {partners === null ? null : partners.length === 0 ? (
        <div className="mt-10">
          <EmptyState icon={Handshake} title="L'annuaire des partenaires arrive bientôt">
            Les partenaires réels seront publiés depuis l'administration (B19), avec logo, description et coordonnées — uniquement sur décision d'Art Event.
          </EmptyState>
        </div>
      ) : (
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="partners-public-grid">
          {partners.map((p) => (
            <div key={p.id} className="card-ae p-6" data-testid={`partner-card-${p.id}`}>
              {p.logo && <img src={p.logo} alt={p.name} className="mb-4 h-14 w-14 rounded-lg object-cover" />}
              <h3 className="font-heading text-xl text-deepgreen">{p.name} {p.featured && <span className="text-gold">★</span>}</h3>
              {p.category && <p className="mt-1 text-xs uppercase tracking-[0.15em] text-muted-foreground">{p.category}</p>}
              {p.location && <p className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground"><MapPin className="h-3.5 w-3.5 text-sage" /> {p.location}</p>}
              {p.description && <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{p.description}</p>}
              {p.link && (
                <a href={p.link} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-deepgreen hover:text-sage" data-testid={`partner-link-${p.id}`}>
                  Visiter <ExternalLink className="h-3.5 w-3.5" />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
